<style lang="less" scoped>
  .keypad {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    background: white;
  }
  .keypad-slot {
    border: 1px solid #18a4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20%;
    height: 48px;
  }
</style>

<template lang="pug">
  .keypad
    .keypad-slot(
      v-for='number in numbers'
      @click='handleClick(number)')
      number-component(
        :number='number',
        :type='"blue"'
        :width='18')
</template>

<script>
import NumberComponent from '@/components/number_panel';

export default {
  data() {
    return {
      numbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  methods: {
    handleClick(number) {
      this.$emit('click', number);
    },
  },
  components: {
    NumberComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/keypad.vue